import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueDarkMode from "@growthbunker/vuedarkmode";

import VueCodeHighlight from 'vue-code-highlight';
 


Vue.config.productionTip = false


Vue.use(VueCodeHighlight)

Vue.use(VueDarkMode, {
  // Specify the components to declare globally in your project
  // When undefined, null or given an empty array, all components will be imported
  components: [
    // Base components
    "alert", "avatar", "badge", "button", "divider", "heading", "icon",  "progress-bar",  "social-button", "spinner",

    // Form components
    "checkbox", "file", "input", "label", "message", "radios", "select", "tabs", "textarea", "toggle"
  ]
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
